import { InjectionToken } from '@angular/core';
import { Dictionary } from '@ngrx/entity';
import { Observable } from 'rxjs';
import { UserGameProfileInterface } from '../+models';

export const USER_GAME_PROFILE_SERVICE = new InjectionToken('UserGameProfileService');

export interface UserGameProfileServiceInterface {
  getUserGameProfiles(keys: string[], methodCode: string): Observable<Dictionary<UserGameProfileInterface>>;
  saveUserGameProfile(userProfile: UserGameProfileInterface): Observable<UserGameProfileInterface>;
}
